import { toast } from 'react-toastify'

import API from "../../api";
import { queryClient } from "../../react-query"
import { useHubAssinatura } from "../../../store/hub/useHubAssinatura";

export class HubAssinaturaModel {
  hubAction = useHubAssinatura.getState().actions

  async details() {
    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['hub', 'assinatura-details'],
        queryFn: async () => await API.get(`/hub/signatures-details`),

      })

      this.hubAction.setDetails(result.data)

      return result
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os detalhes das assinaturas', { theme: 'colored' })
      return false
    }
  }
}
